import React, { FC, useState } from 'react';
import clsx from 'clsx';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import {
  additionalPartnerNavigationLinks, PARTNER_NAVIGATION,
  partnerNavigationLinks,
} from '../../constants/new-partner/partner-navigation';

import './PartnerDetailsLayout.scss';
import { Dropdown } from 'rsuite';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEllipsisVertical } from '@fortawesome/free-solid-svg-icons';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { sentPartnerInvite } from '../../store/merchnts/actions/partners';

interface Props {
  children: React.ReactElement;
}

export const PartnerDetailsLayout: FC<Props> = (props) => {
  const { children } = props;

  const { t } = useTranslation();
  const { partnerId } = useParams();
  const { pathname, state } = useLocation();
  const navigate = useNavigate();

  const { merchantState: { partnerDetailsData, isPartnerDetailsDataLoading }} = useMerchants();

  const [loading, setLoading] = useState<boolean>(false);

  const handleClick = async (): Promise<void> => {
    setLoading(true);
    await sentPartnerInvite(partnerId);
    setLoading(false);
  };

  return (
    <>
      <div>
        <div className="card mb-5">
          <div className="card-body border-bottom d-flex justify-content-between align-items-center">
            <div className="fw-bolder fs-5 fs-sm-3">{partnerDetailsData?.name}</div>
            {
              (!partnerDetailsData?.mainContact?.userCreated && !isPartnerDetailsDataLoading) && (
                <ButtonComponent
                  buttonName={t('PARTNERS.INVITE_BTN_NAME')}
                  buttonType={BUTTON_TYPE.WHITE}
                  onButtonClick={async (): Promise<void> => await handleClick()}
                  loading={loading}
                  additionalClass="d-block w-100px"
                />
              )
            }

          </div>
          <div className="d-flex align-items-center justify-content-between merchant-navigation px-9">
            {
              partnerNavigationLinks
                // .filter(({ path }) => partnerDetailsData?.type?.toLowerCase() === 'integration' ? path !== PARTNER_NAVIGATION.API_KEYS : true)
                .map(({ path, text, additionalClass }) => (
                  <Link
                    key={path}
                    to={`/partners/${partnerId}/${path}`}
                    state={{ ...state }}
                    className={clsx(
                      'align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder text-center px-3 h-70px tab-style',
                      additionalClass,
                      pathname.includes(path) ? 'text-danger tab-bgc' : 'text-dark')
                    }
                  >
                    {t(text)}
                  </Link>
                ))
            }
            <Dropdown
              noCaret
              icon={<FontAwesomeIcon icon={faEllipsisVertical} />}
              placement="bottomEnd"
              className="merchant-hidden-tabs partner-hidden-tabs"
            >
              {
                additionalPartnerNavigationLinks
                  // .filter(({ path }) => partnerDetailsData?.type?.toLowerCase() === 'integration' ? path !== PARTNER_NAVIGATION.API_KEYS : true)
                  .map(({ path, text, additionalClass }) => (
                    <Dropdown.Item
                      key={path}
                      onClick={(): void => navigate(`/partners/${partnerId}/${path}`)}
                      className={clsx(
                        'fw-bolder fs-7',
                        additionalClass,
                        pathname.includes(path) ? 'text-danger tab-bgc' : 'text-dark'
                      )}
                    >
                      {t(text)}
                    </Dropdown.Item>
                  ))
              }
            </Dropdown>

          </div>
        </div>
      </div>
      {children}
    </>
  );
};
